import React from 'react';
import { getAnalysisPreset } from '../config/rwanda';

interface AnalysisSelectorProps {
  analysisTypes: string[];
  selected: string;
  onSelect: (analysisType: string) => void;
}

const AnalysisSelector: React.FC<AnalysisSelectorProps> = ({
  analysisTypes,
  selected,
  onSelect
}) => {
  return (
    <div className="relative">
      <select 
        value={selected}
        onChange={(e) => onSelect(e.target.value)}
        className="bg-white/10 border border-white/20 text-white rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-white/50 min-w-[180px]"
      >
        {analysisTypes.map(type => {
          const preset = getAnalysisPreset(type);
          return (
            <option key={type} value={type} className="text-gray-900">
              {preset?.name || type}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default AnalysisSelector;